// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.episode-countdown {
  background: var(--countdown-bg-color);
  display: flex;
  align-items: center;
  min-height: calc(var(--hero-height-mobile));
  margin-top: calc(var(--navbar-height-mobile) * -1);
  padding-top: var(--navbar-height-mobile);
}
@media (min-width: 1200px) {
  .episode-countdown {
    min-height: calc(var(--hero-height-desktop));
    min-height: calc(var(--hero-height-desktop));
    margin-top: calc(var(--navbar-height-desktop) * -1);
  }
}
.episode-countdown__background-image {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-size: cover;
  background-image: var(--countdown-bg-image-mobile);
}
@media (min-width: 768px) {
  .episode-countdown__background-image {
    background-image: var(--countdown-bg-image-desktop);
  }
}
.episode-countdown__title {
  color: var(--countdown-title-color) !important;
  margin-top: 0 !important;
  margin-bottom: 7px !important;
  font-size: var(--hero-title-font-size-mobile) !important;
}
@media (min-width: 1200px) {
  .episode-countdown__title {
    font-size: var(--hero-title-font-size-desktop) !important;
  }
}
.episode-countdown__subtitle {
  color: var(--countdown-subtitle-color) !important;
  margin-top: 0 !important;
  font-size: var(--hero-subtitle-font-size-mobile) !important;
}
@media (min-width: 1200px) {
  .episode-countdown__subtitle {
    font-size: var(--hero-subtitle-font-size-desktop) !important;
  }
}
.episode-countdown__countdown-description-text {
  color: var(--countdown-small-text-color);
  font-size: 14px;
  text-transform: capitalize;
}
.episode-countdown__countdown {
  margin-top: 30px;
  font-size: 40px;
  display: flex;
  gap: 3px;
}
@media (min-width: 768px) {
  .episode-countdown__countdown {
    font-size: 45px;
    gap: 10px;
  }
}
.episode-countdown__countdown-slice {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 55px;
  font-weight: 600;
  color: var(--countdown-active-numbers-color);
}
@media (min-width: 768px) {
  .episode-countdown__countdown-slice {
    min-width: 60px;
  }
}
.episode-countdown__countdown-separator {
  color: var(--countdown-active-numbers-color);
}
.episode-countdown .inactive-countdown-slice-part {
  color: var(--countdown-inactive-numbers-color) !important;
}
.episode-countdown .ant-statistic-content {
  font-size: 45px;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/EpisodeCountdown/EpisodeCountdown.scss"],"names":[],"mappings":"AAEA;EACI,qCAAA;EAEA,aAAA;EACA,mBAAA;EAEA,2CAAA;EAEA,kDAAA;EACA,wCAAA;AAJJ;AAMI;EAXJ;IAYQ,4CAAA;IACA,4CAAA;IACA,mDAAA;EAHN;AACF;AAKI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kDAAA;AAHR;AAKQ;EATJ;IAUQ,mDAAA;EAFV;AACF;AAKI;EACI,8CAAA;EACA,wBAAA;EACA,6BAAA;EACA,wDAAA;AAHR;AAKQ;EANJ;IAOQ,yDAAA;EAFV;AACF;AAKI;EACI,iDAAA;EACA,wBAAA;EACA,2DAAA;AAHR;AAKQ;EALJ;IAMQ,4DAAA;EAFV;AACF;AAKI;EACI,wCAAA;EACA,eAAA;EACA,0BAAA;AAHR;AAMI;EACI,gBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;AAJR;AAMQ;EANJ;IAOQ,eAAA;IACA,SAAA;EAHV;AACF;AAMI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,4CAAA;AAJR;AAMQ;EARJ;IASQ,eAAA;EAHV;AACF;AAMI;EACI,4CAAA;AAJR;AAOI;EACI,yDAAA;AALR;AAQI;EACI,eAAA;AANR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
